import { useMutation } from '@apollo/client';
import { SAVE_USER_FAVORITE } from '@bechtel/ht-clients-common';
import { SaveToolUserFavoriteInput } from '@bechtel/ht-types';

export const useUpdateToolUserFavorites = (refetchQueries: string[] = ['SearchToolCatalogs']) => {
  const [saveToolUserFavorites, { data, loading, error }] = useMutation(SAVE_USER_FAVORITE);

  const updateToolUserFavorites = (input: SaveToolUserFavoriteInput, onCompleted?: (data: any) => void) => {
    saveToolUserFavorites({
      variables: {
        input: input,
      },
      onCompleted: (data) => {
        onCompleted && onCompleted(data);
      },
      refetchQueries: refetchQueries,
    });
  };

  return { updateToolUserFavorites, data, loading, error };
};
